//ClassDetails.js
import React, { useEffect, useState, useContext} from "react";
import styled from "styled-components";
import axios from "axios";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import ButtonMobile from "../../components/ButtonMobile/ButtonMobile"; //Join the class button
import ButtonBack from "../../components/ButtonMobile/ButtonBack"; //Circle Back Button
import LessonSelector from "../../components/SelectClassButton/SelectClassButton"; //Select Class Buttons
import {LocationPin} from "../../assets/IconSVG.js";
import DateAndTimeBooking from "../../components/Form/DateAndTimeBooking"; //Select 
import Cookies from 'js-cookie';
import api from '../../Api'; // adjust the path based on where api.js is located
import { HistoryContext } from '../../context/historyContext';
import TopSlider from "../../components/PhotoSlider/TopSlider";
import { motion, AnimatePresence } from "framer-motion";
import MessageModal from "../../components/Modal/Modal";
import QuantityDateSelector from "../../components/Modal/QuantityDateSelector";

export const ClassCard = ({ classInfo }) => {
  const navigate = useNavigate()
const [price, setPrice] = useState(0);
const [order, setOrder] = useState({
  course_id:"",
  		price: "",
		name: "",
		option1Value: "",
    option2Value: "",
		fee: "",
	});


  const [date, setDate] = useState('');
  const [time, setTime] = useState('');


  const handleDateTimeChange = (newDate, newTime) => {
    setDate(newDate);
    setTime(newTime);
  };

const [errorFields, setErrorFields] = useState({});



  const validateOrder = (order) => {
  let errors = {};

  for (let key in order) {
    if (order[key] === "") {
      errors[key] = true;
    }
  }
  setErrorFields(errors);
 return Object.keys(errors).length === 0; // Valid form if no errors/ return true or false
};



const setCookie = (name, value) =>{
  Cookies.set(name, value,{
    expires: 1/96, // Cookie expires in 15 mins
    path: '/', // Cookie accessible for the whole site
    secure: process.env.REACT_APP_NODE_ENV === 'production', // Only transmit cookie over HTTPS if in production
    sameSite: 'strict' // Strictly same site; adjust as needed
  })
}

const setCourseCookies = (courseData, programCode) => {
  // Extract only the essential fields we need
  const minimalCourseData = {
    id: courseData.id,
    fee: courseData.fee,
    requireSelection: courseData.requireSelection
  };
  
  // Set activeCourse cookie with minimal data
  setCookie('activeCourse', JSON.stringify({ 
    course: minimalCourseData, 
    program: programCode 
  }));
}



  const handleSubmit = (e) => {
    // Only try to prevent default if e is an event object
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
      e.stopPropagation();
    }

    const activeCourseStr = Cookies.get('activeCourse');
    
    if (activeCourseStr) {
      const activeCourse = JSON.parse(activeCourseStr);
      
      // If requireSelection is false, proceed directly to confirmation
      if (!activeCourse.course?.requireSelection) {
        // Get all classes for this course
        const courseClasses = classInfo.courses.find(c => c.id === activeCourse.course.id)?.classes || [];
        
        // Store class IDs and dates
        const selectedClassIds = courseClasses.map(classItem => classItem.id);
        const selectedDates = courseClasses.map(classItem => ({
          id: classItem.id,
          date: classItem.date,
          name: classItem.name
        }));
        
        // Set default values for direct booking with minimal data
        const defaultBookingData = {
          course: {
            id: activeCourse.course.id,
            fee: activeCourse.course.fee,
            requireSelection: activeCourse.course.requireSelection,
            selectedClassIds: selectedClassIds,
            selectedDates: selectedDates,
            totalPrice: activeCourse.course.fee
          },
          program: activeCourse.program
        };
        
        // Update activeCourse cookie with minimal booking data
        setCookie('activeCourse', JSON.stringify(defaultBookingData));

        const isValid = validateOrder(activeCourse.course);
        if (isValid) {
          navigate(`/en/classconfirmpayment`);
        }
        return;
      }
      
      // If requireSelection is true, show the quantity/date selection modal
      setTimeout(() => {
        setModalOpen(true);
        setModalTemplate("quantityDateSelector");
      }, 100);
    }
  };

  const handleModalConfirm = (data) => {
    console.log("Confirmed data:", data);
    setModalOpen(false);
    
    // Get the complete data from the updated cookie
    const updatedCookieStr = Cookies.get('activeCourse');
    
    if (updatedCookieStr) {
      try {
        const updatedCookie = JSON.parse(updatedCookieStr);
        console.log("Updated cookie from modal:", updatedCookie);
        
        // Make sure we have the selected dates from the modal
        if (!updatedCookie.selectedDates) {
          console.error("No selectedDates in cookie after modal confirmation");
          
          // Fallback: Use data from the modal directly
          const selectedClassIds = data.selectedDates?.map(date => date.id) || [];
          
          // Get the base cookie data from the original cookie
          const originalCookieStr = Cookies.get('activeCourse');
          const activeCourse = JSON.parse(originalCookieStr);
          
          // Create a new cookie with the selected dates
          setCookie('activeCourse', JSON.stringify({
            course: {
              id: activeCourse.course.id,
              fee: activeCourse.course.fee,
              requireSelection: activeCourse.course.requireSelection,
              selectedClassIds,
              selectedDates: data.selectedDates,
              totalPrice: data.totalPrice
            },
            program: activeCourse.program,
            selectedDates: data.selectedDates, // Add at top level too
            selectedClassIds: selectedClassIds // Add at top level too
          }));
        }
        
        // Navigate to confirmation page
        navigate(`/en/classconfirmpayment`);
      } catch (error) {
        console.error("Error processing cookie after modal:", error);
      }
    }
  };


  const handleModalCancel = () => {
    setModalOpen(false);
  };





const [activeCourse, setActiveCourse] = useState(null);
const [activeProgram, setActiveProgram] = useState(null)
const { history, setHistory } = useContext(HistoryContext);
const [slideDirection, setSlideDirection] = useState('right');
const [isModalOpen, setModalOpen] = useState(false);
const [modalTemplate, setModalTemplate] = useState(null);
const [autoClose, setAutoClose] = useState(false);
const [isQuantityDateSelectorVisible, setQuantityDateSelectorVisible] = useState(false);



useEffect(() => {
  localStorage.setItem('history', JSON.stringify(history));
}, [history]);


useEffect(() => {
setHistory(location.pathname + location.search);

//  Cookies.set('testingSession', JSON.stringify({ test: "test1" }));

  if (classInfo.courses && classInfo.courses.length > 0) {
    let activeCourseFromCookie = Cookies.get('activeCourse');
    const { id, code } = classInfo;
        console.log(code)

    if (activeCourseFromCookie) {
      activeCourseFromCookie = JSON.parse(activeCourseFromCookie);

      if (activeCourseFromCookie.program.id === classInfo.id) {
        setActiveCourse(activeCourseFromCookie.course);
        setActiveProgram(activeCourseFromCookie.program);
      } else {
        // Clean up all course-related cookies
        Cookies.remove('activeCourseInfo');
        
        // Clean up class chunk cookies
        const classesInfo = Cookies.get('activeCourseClassesInfo');
        if (classesInfo) {
          const { totalChunks } = JSON.parse(classesInfo);
          for (let i = 0; i < totalChunks; i++) {
            Cookies.remove(`activeCourseClasses_${i}`);
          }
          Cookies.remove('activeCourseClassesInfo');
        }
       const firstAvailableCourse = classInfo.courses.find(course => (course.availability === null || course.availability > 0) && course.open === 1);
        if (firstAvailableCourse) {
          setActiveCourse(firstAvailableCourse);
          setActiveProgram(code);
          setCourseCookies(firstAvailableCourse, code);
        } else {
          setActiveCourse(null);
          setActiveProgram(null);
          // Clean up all course-related cookies
          Cookies.remove('activeCourseInfo');
          
          // Clean up class chunk cookies
          const classesInfo = Cookies.get('activeCourseClassesInfo');
          if (classesInfo) {
            const { totalChunks } = JSON.parse(classesInfo);
            for (let i = 0; i < totalChunks; i++) {
              Cookies.remove(`activeCourseClasses_${i}`);
            }
            Cookies.remove('activeCourseClassesInfo');
          }
          console.log('No available courses found. activeCourseFromCookie');
        }
      }
    } else {
      const firstAvailableCourse = classInfo.courses.find(course => (course.availability === null || course.availability > 0) && course.open === 1);
      if (firstAvailableCourse) {
        setCourseCookies(firstAvailableCourse, code);
        setActiveCourse(firstAvailableCourse);
        setActiveProgram(code);
      } else {
        setActiveCourse(null);
        setActiveProgram(null);
        // Clean up all course-related cookies
        Cookies.remove('activeCourseInfo');
        
        // Clean up class chunk cookies
        const classesInfo = Cookies.get('activeCourseClassesInfo');
        if (classesInfo) {
          const { totalChunks } = JSON.parse(classesInfo);
          for (let i = 0; i < totalChunks; i++) {
            Cookies.remove(`activeCourseClasses_${i}`);
          }
          Cookies.remove('activeCourseClassesInfo');
        }
        console.log('No available courses found.');
      }
    }
  }
  // Cleanup function
  // return () => {
  //   Cookies.remove('activeCourse');
  // };

}, [classInfo]);

useEffect(() => {
  if (activeCourse !== null) {
    try {
      const { id, code } = classInfo;
      
      // Only store essential data
      const minimalCourseData = {
        id: activeCourse.id,
        requireSelection: activeCourse.requireSelection ? 1 : 0
      };
      
      // Create cookie data object
      const cookieData = {
        course: minimalCourseData,
        program: code
      };

      // Stringify and set cookie
      setCookie('activeCourse', JSON.stringify(cookieData));
    } catch (err) {
      console.error('Error setting activeCourse cookie:', err);
      Cookies.remove('activeCourse');
    }
  } else {
    Cookies.remove('activeCourse');
  }
}, [activeCourse, classInfo]);


const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const single = queryParams.get('single') === 'true';

const handleOptionClick = (option) => {
    if (activeCourse && activeCourse.code !== option.code) {
      setSlideDirection(activeCourse.code < option.code ? 'right' : 'left');
    }
  };




  return (
    <>
      <CardContent>
  
          {!single && (     <ButtonWrapper><ButtonBack onClick={() => {
            navigate(-1);
          }}>
            </ButtonBack>
        </ButtonWrapper>)}
         
         {classInfo?.images && <TopSlider images={classInfo?.images} />}
              <CardContentWrapper>
                {/* Header Section - Category Tag */}
                {classInfo.category && <Label>{classInfo.category}</Label>}
                
                {/* Program Title */}
                <ClassTitle>{classInfo.name}</ClassTitle>
                
                {/* Date Info with Calendar Icon */}
                {(classInfo.dateRange || classInfo.date) && (
                  <DateInfoRow>
                    <CalendarIconBox>
                      <CalendarIconImage>📅</CalendarIconImage>
                    </CalendarIconBox>
                    <DateText>{classInfo.dateRange || classInfo.date}</DateText>
                  </DateInfoRow>
                )}
                
                {/* Location Info with Pin */}
                {classInfo.venue && (
                  <LocationCard>
                    <LocationPinWrapper>
                      <LocationPin />
                    </LocationPinWrapper>
                    <LocationText>{classInfo.venue}</LocationText>
                  </LocationCard>
                )}
                
                {/* Download Brochure Button - Only shows if brochure_url is set in database */}
                {classInfo.brochure_url && (
                  <DownloadBrochureButton 
                    href={classInfo.brochure_url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    download
                  >
                    <DownloadIcon>📥</DownloadIcon>
                    <span>Download Brochure</span>
                  </DownloadBrochureButton>
                )}

        {/* ***********************************
              SELECT BELOW AREA - OPTIONAL
        *********************************** */}
  {classInfo?.useTimeslotMode? (

<>
 <Subheader>Select your course</Subheader>

        <DateAndTimeBooking 
          courses={classInfo?.courses?.filter(course => course.open === 1)} 
          program={classInfo} 
          setActiveCourse={setActiveCourse} 
          activeCourse={activeCourse} 
          errorFields={errorFields} 
          language="en"
        />
</>
  ) : ( 

<>
<Subheader>Course options</Subheader>

        <LessonSelector 
          courses={classInfo?.courses?.filter(course => course.open === 1)} 
          program={classInfo} 
          setActiveCourse={setActiveCourse} 
          activeCourse={activeCourse} 
          errorFields={errorFields} 
          handleOptionClick={handleOptionClick}
        />
    </>
)

}


<Wrapper>

   {/* ***********************************
      Dynamically changed course details
    *********************************** */}
   {activeCourse && (
    <AnimatePresence mode="wait">
      {classInfo?.courses
        .filter(option => activeCourse?.id === option.id)
        .map((option) => (
          <motion.div
            key={option.id}
            initial={{ 
              opacity: 0, 
              x: slideDirection === 'right' ? 40 : -40 
            }}
            animate={{ 
              opacity: 1, 
              x: 0 
            }}
            exit={{ 
              opacity: 0, 
              x: slideDirection === 'right' ? -40 : 40 
            }}
            transition={{ 
              duration: 0.3, 
              ease: [0.4, 0, 0.2, 1]
            }}
            style={{ width: '100%' }}
          >
            <CourseDetailsCard>
              {/* Date Range */}
              {option.dateRange && (
                <DetailRow>
                  <DetailRowLabel>活動日期:</DetailRowLabel>
                  <DetailRowValue>{option.dateRange}</DetailRowValue>
                </DetailRow>
              )}
              
              {/* Location */}
              {option.venue && (
                <DetailRow>
                  <DetailRowLabel>地點:</DetailRowLabel>
                  <DetailRowValue>{option.venue}</DetailRowValue>
                </DetailRow>
              )}
              
              {/* Check-in Time */}
              {option.checkInTime && (
                <DetailRow>
                  <DetailRowLabel>入營時間:</DetailRowLabel>
                  <DetailRowValue>{option.checkInTime}</DetailRowValue>
                </DetailRow>
              )}
              
              {/* Check-out Time */}
              {option.checkOutTime && (
                <DetailRow>
                  <DetailRowLabel>退營時間:</DetailRowLabel>
                  <DetailRowValue>{option.checkOutTime}</DetailRowValue>
                </DetailRow>
              )}
              
              {/* Fee */}
              {option.feeDescription && (
                <DetailRow>
                  <DetailRowLabel>收費:</DetailRowLabel>
                  <DetailRowValue>{option.feeDescription}</DetailRowValue>
                </DetailRow>
              )}
              
              {/* Additional HTML Details */}
              {option.details && (
                <DynamicallyChangeContent>
                  <div dangerouslySetInnerHTML={{ __html: option?.details }} />
                </DynamicallyChangeContent>
              )}
            </CourseDetailsCard>
          </motion.div>
        ))}
    </AnimatePresence>
   )}
   
</Wrapper>

<Subheader>What to expect</Subheader>

        <ClassDescription>
           <div dangerouslySetInnerHTML={{ __html: classInfo?.description }} />
          {/* <span>{classInfo?.description}</span> */}
        </ClassDescription>




        <JoinClassFooterWrapper>

{!activeCourse ? (
    <OptionListPrice> Please select </OptionListPrice>
) : (
    activeCourse?.fee === 0 ? (
        <OptionListPrice>
            {activeCourse?.option1value}<br />
            {activeCourse?.option2value}
        </OptionListPrice>
    ) : (
        <OptionListPrice>
            HK$ {activeCourse?.fee}
        </OptionListPrice>
    )
)}
               
               <ButtonMobile onClick={handleSubmit}>BOOK</ButtonMobile>

         
        </JoinClassFooterWrapper>

        {isModalOpen && (
          <MessageModal
            isOpen={isModalOpen}
            setModalOpen={setModalOpen}
            template={modalTemplate}
            onConfirm={handleModalConfirm}
            onCancel={handleModalCancel}
            baseFee={activeCourse?.fee || 0}
            classDates={activeCourse?.classes || []}
            maxQuantity={activeCourse?.noofclasses || activeCourse?.classes?.length || 0}
          />
        )}

        <FooterWrapper>
          <div>
            Powered by <img src="/dynamic_logo.svg" alt="Dynevents Logo" /> | booking.dynevents.com
          </div>
        </FooterWrapper>
             </CardContentWrapper>
      </CardContent>
    </>
  );
};

export const ClassDetails = () => {

const [data, setData] = useState([]);
const location = useLocation();
	const {program_code} = useParams();

const host = window.location.hostname;
const subdomain = host.split('.')[0];
const shopName = subdomain;
  
  
  useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await api.get(
					`/classBooking/api/class/${program_code}`
				);

				// let uniqueArray = [...new Set(res.data.map((item) => item.category))]; // Remove duplicates

				// let newtabValues = [
				// 	{ name: "tab_1", label: "All Events" },
				// 	...uniqueArray.map((item, index) => ({
				// 		name: `tab_${index + 2}`, // Start from tab_2
				// 		label: item,
				// 	})),
				// ];
				setData(res.data);
          

			} catch (err) {
				console.log(err);
			}
		};

		fetchData();
		// setResultChange("All");

		// const intervalId = setInterval(fetchData, 1000);

		// Clean up the interval when the component unmounts or when dependencies change
		// return () => {
		// 	clearInterval(intervalId);
		// };
	}, []);


  return (
    <>
        <ClassCard classInfo={data} />
    </>
  );
};
export default ClassDetails;

//STYLED-COMPONENTS:
export const CardContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding-bottom: 100px;
  color: #333;
  background-color: #f9f9f9;
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 22px;
  left: 22px;
  z-index: 10;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
`;

export const ClassImage = styled.img`
  object-fit: cover;
  object-position: center;
  width: 100%;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

export const CardContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px;
  background-color: white;
  border-radius: 20px;
  margin-top: -20px;
  position: relative;
  box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.05);
`;

export const ClassTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.3;
  color: #1a1a1a;
  margin-top: 12px;
  margin-bottom: 8px;
  letter-spacing: -0.02em;
`;

export const Label = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 500;
  background-color: #e8f4fd;
  color: #1a73e8;
  border-radius: 8px;
  padding: 6px 14px;
  display: inline-block;
  margin-bottom: 8px;
`;

// Date Info Row with Calendar Icon
export const DateInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #333;
`;

export const CalendarIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;

export const CalendarIconImage = styled.span`
  font-size: 22px;
`;

export const DateText = styled.span`
  font-weight: 500;
  font-size: 16px;
  color: #333;
`;

// Location Card
export const LocationCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: #f5f7f9;
  border-radius: 16px;
  padding: 16px 20px;
  margin: 12px 0;
  width: 100%;
`;

export const LocationPinWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 24px;
  flex-shrink: 0;
  padding-top: 4px;
  
  svg {
    width: 20px;
    height: 20px;
    fill: #555;
  }
`;

export const LocationText = styled.span`
  flex: 1;
  font-family: 'Lora', sans-serif;
  font-size: 15px;
  color: #333;
  line-height: 1.6;
`;

// Download Brochure Button - Modern glassmorphism style
export const DownloadBrochureButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 100%;
  padding: 16px 28px;
  margin: 24px 0;
  background: rgba(250, 250, 250, 0.95);
  backdrop-filter: blur(10px);
  color: #333;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 50px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    background: #1a1a1a;
    color: white;
    border-color: transparent;
    transform: scale(1.01);
    
    span:first-child {
      transform: translateY(2px);
    }
  }
  
  &:active {
    transform: scale(0.99);
  }
`;

export const DownloadIcon = styled.span`
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
`;

// Course Details Card
export const CourseDetailsCard = styled.div`
  width: 100%;
  background-color: transparent;
  padding: 16px 0;
  margin-top: 0;
`;

export const DetailRow = styled.div`
  margin-bottom: 24px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailRowLabel = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
`;

export const DetailRowValue = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #4a5568;
  background-color: #eef3f6;
  border-radius: 14px;
  padding: 16px 20px;
  line-height: 1.6;
`;

export const DetailsContainer = styled.div`
  font-family: 'Lora', sans-serif;
  font-size: 15px;
  text-align: left;
  background-color: #fff5ee;
  color: #333;
  border-radius: 12px;
  padding: 12px 16px;
  margin: 12px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-left: 3px solid #ff9966;
`;

export const ClassVenue = styled.div`
  font-family: 'Lora', sans-serif;
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  margin: 12px 0;
  display: flex;
  align-items: center;
  width: 100%;
  color: #666;
  
  svg {
    width: 20px;
    margin-right: 10px;
    fill: #666;
  }
`;

export const Subheader = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 18px;
  margin: 28px 0 16px 0;
  width: 100%;
  color: #1a1a1a;
  padding: 0;
`;

export const ClassDetailsStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 12px;
  width: 100%;
  padding: 16px 0;
  background-color: #fafafa;
  border-radius: 12px;
  padding: 16px;
  margin: 12px 0;
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.03);
`;

export const DetailItem = styled.div`
  display: contents;
`;

export const DetailLabel = styled.span`
  color: #777;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 0;
`;

export const DetailValue = styled.span`
  font-family: 'Lora', sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #333;
  padding: 4px 0;
`;

export const TransportationNote = styled.p`
  font-family: 'Lora', sans-serif;
  font-style: italic;
  font-weight: 700;
  font-size: 14px;
  margin-top: 12px;
  color: #e74c3c;
  text-align: center;
  background-color: rgba(231, 76, 60, 0.1);
  padding: 8px 12px;
  border-radius: 8px;
  width: 100%;
`;

export const ClassDescription = styled.div`
  background-color: #fafafa;
  width: 100%;
  color: #444;
  font-size: 15px;
  line-height: 1.7;
  padding: 20px;
  border-radius: 20px;
  margin: 12px 0;
  
  p {
    margin-bottom: 12px;
  }
  
  ul, ol {
    padding-left: 24px;
    margin-bottom: 12px;
  }
`;

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 36px;
  font-size: 12px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
  
  @media (min-width: 500px) {
    width: 500px;
    left: calc((100vw - 500px) / 2);
    right: calc((100vw - 500px) / 2);
  }

  img {
    display: inline-block;
    width: 20px;
    vertical-align: middle;
    margin: 0 4px;
  }
  
  a {
    color: #4169e1;
    text-decoration: none;
    font-weight: 500;
  }
`




const JoinClassFooterWrapper = styled.div`
  position: fixed;
  bottom: 36px;
  left: 0;
  right: 0;
  padding: 16px 20px;
  border-radius: 24px 24px 0 0;
  background-color: white;
  z-index: 1000;
  width: 100%;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.08);
  
  @media (min-width: 500px) {
    width: 500px;
    left: calc((100vw - 500px) / 2);
    right: calc((100vw - 500px) / 2);
  }
  
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  div {
    flex: 1;
  }

  button {
    flex: 1;
    border-radius: 14px;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0;
    box-shadow: none;
    transition: transform 0.15s ease, opacity 0.15s ease;
    
    &:active {
      transform: scale(0.98);
      opacity: 0.9;
    }
  }
`;


const BookingFooterWrapper = styled.div`
  position: fixed;
  bottom: 36px;
  left: 0;
  right: 0;
  padding: 16px 24px;
  border-radius: 20px 20px 0 0;
  background-color: white;
  z-index: 1000;
  width: 100%;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  
  @media (min-width: 500px) {
    width: 500px;
    left: calc((100vw - 500px) / 2);
    right: calc((100vw - 500px) / 2);
  }
  
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  div {
    flex: 2;
  }

  button {
    flex: 1;
    border-radius: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    
    &:active {
      transform: translateY(2px);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    }
  }
`;

export const OptionListPrice = styled.div`
  text-align: left;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  font-family: 'Poppins', sans-serif;
`;

export const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: 16px 0;
`;

export const DynamicallyChangeContent = styled.div`
  text-align: left;
  color: #333;
  width: 100%;
  height: auto;
  flex: 1;
  overflow: hidden;
  padding: 0;
  
  h2 {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: #333;
    margin: 24px 0 10px 0;
    
    &:first-child {
      margin-top: 0;
    }
  }
  
  p {
    font-family: 'Poppins', sans-serif;
    font-size: 16px !important;
    color: #4a5568;
    background-color: #eef3f6;
    border-radius: 14px;
    padding: 16px 20px;
    line-height: 1.6;
    margin: 0 0 8px 0;
  }
  
  br {
    display: none;
  }
  
  ul {
    list-style-type: disc;
    padding-left: 24px;
    font-size: 16px;
    line-height: 1.6;
    
    li {
      margin-bottom: 8px;
    }
  }
`;

export const DynamicallyChangeContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  background-color: transparent;
  padding: 16px 0;
  height: auto;
  position: relative;
  margin-top: 0;
`;

export const OptionListTitle = styled.div`
  width: 100%;
  margin: 0 0 16px 0;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  color: #1a1a1a;
`;

